// extracted by mini-css-extract-plugin
module.exports = {"price":"_93444fe79c--price--sZwIA","value":"_93444fe79c--value--idHVm","currency":"_93444fe79c--currency--qMhoF"};